<template>
  <div class="page-content">
    <main class="container mx-auto px-4 py-8">
      <div class="bg-white rounded-xl shadow-md p-6 mb-8">
        <div class="flex items-center mb-4">
          <i class="fas fa-info-circle text-blue-500 mr-2"></i>
          <h2 class="text-xl font-semibold text-gray-800">举办大型展览展销活动"一件事"</h2>
        </div>
        <p class="text-gray-700 mb-4">在本市举办以营利为目的，单场次参加人数1000人以上，租用、借用或者以其他形式临时占用场所、场地的展览展销活动。</p>
        <div class="note-box">
          <p class="text-gray-800 text-sm">
            <i class="fas fa-exclamation-circle text-amber-500 mr-1"></i>
            注意：当前正在进行"按材料清单准备材料并提交至场馆安保部"步骤，请上传所需文件。
          </p>
        </div>
      </div>

      <!-- 移动端步骤指示器 -->
      <div class="mobile-step-indicator bg-white rounded-xl shadow-md p-4">
        <div class="flex items-center">
          <div class="w-8 h-8 rounded-full bg-blue-600 text-white flex items-center justify-center font-bold">3</div>
          <div class="ml-3 flex-1">
            <div class="text-sm font-medium text-gray-800">按材料清单准备材料并提交至场馆安保部</div>
            <div class="text-xs text-gray-500">正在进行</div>
          </div>
          <div class="flex items-center text-blue-600">
            <span class="text-xs mr-1">查看流程</span>
            <i class="fas fa-chevron-right text-xs"></i>
          </div>
        </div>
      </div>

      <div class="main-content flex flex-col md:flex-row gap-8">
        <!-- 左侧流程步骤 - 调整宽度确保11个节点完整展示 -->
        <div class="desktop-step-container w-full md:w-auto lg:w-auto">
          <div class="bg-white rounded-xl shadow-md p-6">
            <h3 class="text-lg font-semibold text-gray-800 mb-4">申报流程步骤</h3>
            <!-- 增加卡片间隔 -->
            <div class="space-y-4 relative">
              <!-- 步骤1: 提交基础信息 -->
              <div @click="stepSelected(1)"  :class="{'step-active':step===1}"
                   class="step-card bg-white border-2 border-blue-400 rounded-lg shadow p-4 animate-fade-in delay-100 form-step relative">
                <div class="flex items-center mb-3">
                  <div class="step-number mr-3" :class="{'step-number-active':step===1}">1</div>
                  <h4 class="font-medium text-gray-800">提交基础信息</h4>
                </div>
                <p class="text-gray-600 text-sm">活动策划阶段，确定活动基本信息</p>
              </div>

              <!-- 步骤2: 展览会备案 - 需要填报资料，通过边框颜色表示 -->
              <div @click="stepSelected(2)"  :class="{'step-active':step===2}"
                   class="step-card bg-white border-2 border-blue-400 rounded-lg shadow p-4 animate-fade-in delay-100 form-step relative">
                <div class="flex items-center mb-3">
                  <div class="step-number mr-3" :class="{'step-number-active':step===2}">2</div>
                  <h4 class="font-medium text-gray-800">展览会备案</h4>
                </div>
                <div class="flex items-center text-blue-600 text-xs mb-2">
                  <i class="fas fa-file-alt mr-1"></i>
                  <span>已完成</span>
                </div>
                <p class="text-gray-600 text-sm">完成备案后获得"备案回执"</p>
              </div>

              <!-- 步骤3: 准备材料并提交 - 选中状态，通过背景色表示 -->
              <div @click="stepSelected(3)"  :class="{'step-active':step===3}"
                   class="step-card bg-white border-2 border-blue-400 rounded-lg shadow p-4 animate-fade-in delay-100 form-step relative">
                <div class="flex items-center mb-3">
                  <div class="step-number mr-3" :class="{'step-number-active':step===3}">3</div>
                  <h4 class="font-medium text-gray-800">按材料清单准备材料并提交至场馆安保部</h4>
                </div>
                <div class="flex items-center text-blue-600 text-xs mb-2">
                  <i class="fas fa-file-alt mr-1"></i>
                  <span>正在进行</span>
                </div>
                <p class="text-gray-600 text-sm">按材料清单准备材料并提交至场馆安保部</p>
              </div>

              <!-- 步骤4: 场馆安保部审核 -->
              <div class="step-card bg-white rounded-lg shadow p-4 animate-fade-in delay-300 relative opacity-70">
                <div class="flex items-center mb-3">
                  <div class="step-number mr-3">4</div>
                  <h4 class="font-medium text-gray-800">场馆安保部审核纸质材料</h4>
                </div>
                <p class="text-gray-600 text-sm">安保部门审核提交的材料</p>

                <!-- 条件分支 -->
                <div class="conditional-branch mt-2">
                  <p class="text-xs text-gray-600 mb-1">
                    <i class="fas fa-arrow-right text-amber-500 mr-1"></i>
                    如材料不完整或不符合要求，则需补充完善材料，并重新提交审核
                  </p>
                  <p class="text-xs text-gray-600">
                    <i class="fas fa-arrow-right text-green-500 mr-1"></i>
                    如审核通过，则继续后续步骤
                  </p>
                </div>
              </div>

              <!-- 步骤5: 公安报批 - 需要填报资料，通过边框颜色表示 -->
              <div @click="stepSelected(5)"  :class="{'step-active':step===5}"
                   class="step-card bg-white border-2 border-blue-400 rounded-lg shadow p-4 animate-fade-in delay-400 form-step relative opacity-70">
                <div class="flex items-center mb-3">
                  <div class="step-number mr-3" :class="{'step-number-active':step===5}">5</div>
                  <h4 class="font-medium text-gray-800">公安报批</h4>
                </div>
                <div class="flex items-center text-blue-600 text-xs mb-2">
                  <i class="fas fa-file-alt mr-1"></i>
                  <span>未开始</span>
                </div>
                <p class="text-gray-600 text-sm">展前20个工作日提交</p>
              </div>

              <!-- 步骤6: 消防报备 - 需要填报资料，通过边框颜色表示 -->
              <div @click="stepSelected(6)"  :class="{'step-active':step===6}"
                   class="step-card bg-white border-2 border-blue-400 rounded-lg shadow p-4 animate-fade-in delay-500 form-step relative opacity-70">
                <div class="flex items-center mb-3">
                  <div class="step-number mr-3" :class="{'step-number-active':step===6}">6</div>
                  <h4 class="font-medium text-gray-800">消防报备</h4>
                </div>
                <p class="text-gray-600 text-sm">在公安安全许可后、展会前提交即可</p>
              </div>

              <!-- 步骤7: 现场安全监管报备 - 需要填报资料，通过边框颜色表示 -->
              <div @click="stepSelected(7)"  :class="{'step-active':step===7}"
                   class="step-card bg-white border-2 border-blue-400 rounded-lg shadow p-4 animate-fade-in delay-600 form-step relative opacity-70">
                <div class="flex items-center mb-3">
                  <div class="step-number mr-3" :class="{'step-number-active':step===7}">7</div>
                  <h4 class="font-medium text-gray-800">现场安全监管报备</h4>
                </div>
                <p class="text-gray-600 text-sm">开展前递交资料，资料被接收即视为备案成功，无需等待审批</p>
              </div>

              <!-- 步骤8: 大型食品展销会相关材料申报 - 需要填报资料，通过边框颜色表示 -->
              <div @click="stepSelected(8)"  :class="{'step-active':step===8}"
                   class="step-card bg-white border-2 border-blue-400 rounded-lg shadow p-4 animate-fade-in delay-700 form-step relative opacity-70 food-exhibition-only">
                <div class="flex items-center mb-3">
                  <div class="step-number mr-3" :class="{'step-number-active':step===8}">8</div>
                  <h4 class="font-medium text-gray-800">大型食品展销会相关材料申报</h4>
                </div>
                <p class="text-gray-600 text-sm">仅大型食品展销会类型需要填报资料</p>
              </div>

              <!-- 步骤9: 场馆周边户外广告备案 - 需要填报资料，通过边框颜色表示 -->
              <div @click="stepSelected(9)"  :class="{'step-active':step===9}"
                   class="step-card bg-white border-2 border-blue-400 rounded-lg shadow p-4 animate-fade-in delay-800 form-step relative opacity-70">
                <div class="flex items-center mb-3">
                  <div class="step-number mr-3" :class="{'step-number-active':step===9}">9</div>
                  <h4 class="font-medium text-gray-800">场馆周边户外广告备案</h4>
                </div>
                <p class="text-gray-600 text-sm">一般由场馆协助办理</p>
              </div>

              <!-- 步骤10: 反恐怖和特巡警支队报备 - 需要填报资料，通过边框颜色表示 -->
              <div @click="stepSelected(10)"  :class="{'step-active':step===10}"
                   class="step-card bg-white border-2 border-blue-400 rounded-lg shadow p-4 animate-fade-in delay-900 form-step relative opacity-70">
                <div class="flex items-center mb-3">
                  <div class="step-number mr-3" :class="{'step-number-active':step===10}">10</div>
                  <h4 class="font-medium text-gray-800">反恐怖和特巡警支队报备</h4>
                </div>
                <p class="text-gray-600 text-sm">开展前提交</p>
              </div>

              <!-- 步骤11: 报批结束 -->
              <div class="step-card bg-white rounded-lg shadow p-4 animate-fade-in delay-1000 relative opacity-70">
                <div class="flex items-center mb-3">
                  <div class="step-number mr-3">11</div>
                  <h4 class="font-medium text-gray-800">报批结束</h4>
                </div>
                <p class="text-gray-600 text-sm">完成所有审批流程</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧文件列表 -->
        <step-one v-if="step===1"/>
        <div v-else class="document-list w-full md:flex-1">
          <div class="bg-white rounded-xl shadow-md p-6">
            <div class="flex items-center justify-between mb-6">
              <div>
                <h3 class="text-xl font-semibold text-gray-800">需提交文件清单</h3>
                <p class="text-gray-600 text-sm mt-1">步骤3：按材料清单准备材料并提交至场馆安保部</p>
              </div>
              <div class="flex items-center">
                <div class="text-sm text-gray-600 mr-2">总进度：</div>
                <div class="w-32 bg-gray-200 rounded-full h-2.5">
                  <div class="bg-blue-600 h-2.5 rounded-full" style="width: 17%"></div>
                </div>
                <div class="text-sm font-medium text-blue-600 ml-2">1/6</div>
              </div>
            </div>

            <div class="space-y-4">
              <!-- 文件1 -->
              <div class="document-item border border-gray-200 rounded-lg p-4">
                <div class="flex flex-col md:flex-row md:items-center md:justify-between">
                  <div class="mb-3 md:mb-0">
                    <h4 class="font-medium text-gray-800">搭建服务合同、安全生产管理协议</h4>
                    <p class="text-gray-500 text-xs mt-1">与搭建服务提供商签订的正式合同及安全协议</p>
                  </div>
                  <div class="flex flex-col md:flex-row md:items-center space-y-2 md:space-y-0 md:space-x-2">
                    <div class="status-badge status-pending">
                      <i class="fas fa-clock mr-1"></i>未上传
                    </div>
                    <div class="flex space-x-2">
                      <button class="btn-file-action btn-download">
                        <i class="fas fa-download mr-1"></i>下载模板
                      </button>
                      <button class="btn-file-action btn-download">
                        <i class="fas fa-file-alt mr-1"></i>下载范文
                      </button>
                      <button class="btn-file-action btn-upload">
                        <i class="fas fa-upload mr-1"></i>上传文件
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 文件2 -->
              <div class="document-item border border-gray-200 rounded-lg p-4">
                <div class="flex flex-col md:flex-row md:items-center md:justify-between">
                  <div class="mb-3 md:mb-0">
                    <h4 class="font-medium text-gray-800">搭建单位资质证明</h4>
                    <p class="text-gray-500 text-xs mt-1">搭建单位的相关资质证书复印件</p>
                  </div>
                  <div class="flex flex-col md:flex-row md:items-center space-y-2 md:space-y-0 md:space-x-2">
                    <div class="status-badge status-pending">
                      <i class="fas fa-clock mr-1"></i>未上传
                    </div>
                    <div class="flex space-x-2">
                      <button class="btn-file-action btn-download">
                        <i class="fas fa-download mr-1"></i>下载模板
                      </button>
                      <button class="btn-file-action btn-download">
                        <i class="fas fa-file-alt mr-1"></i>下载范文
                      </button>
                      <button class="btn-file-action btn-upload">
                        <i class="fas fa-upload mr-1"></i>上传文件
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 文件3 -->
              <div class="document-item border border-gray-200 rounded-lg p-4">
                <div class="flex flex-col md:flex-row md:items-center md:justify-between">
                  <div class="mb-3 md:mb-0">
                    <h4 class="font-medium text-gray-800">搭建公司营业执照</h4>
                    <p class="text-gray-500 text-xs mt-1">搭建公司的营业执照复印件（加盖公章）</p>
                  </div>
                  <div class="flex flex-col md:flex-row md:items-center space-y-2 md:space-y-0 md:space-x-2">
                    <div class="status-badge status-completed">
                      <i class="fas fa-check mr-1"></i>已上传
                    </div>
                    <div class="flex space-x-2">
                      <button class="btn-file-action btn-download">
                        <i class="fas fa-download mr-1"></i>下载模板
                      </button>
                      <button class="btn-file-action btn-download">
                        <i class="fas fa-file-alt mr-1"></i>下载范文
                      </button>
                      <button class="btn-file-action btn-upload">
                        <i class="fas fa-redo mr-1"></i>重新上传
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 文件4 -->
              <div class="document-item border border-gray-200 rounded-lg p-4">
                <div class="flex flex-col md:flex-row md:items-center md:justify-between">
                  <div class="mb-3 md:mb-0">
                    <h4 class="font-medium text-gray-800">搭建安全保证书</h4>
                    <p class="text-gray-500 text-xs mt-1">搭建单位出具的安全责任保证书</p>
                  </div>
                  <div class="flex flex-col md:flex-row md:items-center space-y-2 md:space-y-0 md:space-x-2">
                    <div class="status-badge status-pending">
                      <i class="fas fa-clock mr-1"></i>未上传
                    </div>
                    <div class="flex space-x-2">
                      <button class="btn-file-action btn-download">
                        <i class="fas fa-download mr-1"></i>下载模板
                      </button>
                      <button class="btn-file-action btn-download">
                        <i class="fas fa-file-alt mr-1"></i>下载范文
                      </button>
                      <button class="btn-file-action btn-upload">
                        <i class="fas fa-upload mr-1"></i>上传文件
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 文件5 -->
              <div class="document-item border border-gray-200 rounded-lg p-4">
                <div class="flex flex-col md:flex-row md:items-center md:justify-between">
                  <div class="mb-3 md:mb-0">
                    <h4 class="font-medium text-gray-800">安保服务合同(搭建期间)</h4>
                    <p class="text-gray-500 text-xs mt-1">搭建期间的安保服务协议</p>
                  </div>
                  <div class="flex flex-col md:flex-row md:items-center space-y-2 md:space-y-0 md:space-x-2">
                    <div class="status-badge status-pending">
                      <i class="fas fa-clock mr-1"></i>未上传
                    </div>
                    <div class="flex space-x-2">
                      <button class="btn-file-action btn-download">
                        <i class="fas fa-download mr-1"></i>下载模板
                      </button>
                      <button class="btn-file-action btn-download">
                        <i class="fas fa-file-alt mr-1"></i>下载范文
                      </button>
                      <button class="btn-file-action btn-upload">
                        <i class="fas fa-upload mr-1"></i>上传文件
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 文件6 -->
              <div class="document-item border border-gray-200 rounded-lg p-4">
                <div class="flex flex-col md:flex-row md:items-center md:justify-between">
                  <div class="mb-3 md:mb-0">
                    <h4 class="font-medium text-gray-800">安保服务合同(活动期间)</h4>
                    <p class="text-gray-500 text-xs mt-1">活动期间的安保服务协议</p>
                  </div>
                  <div class="flex flex-col md:flex-row md:items-center space-y-2 md:space-y-0 md:space-x-2">
                    <div class="status-badge status-pending">
                      <i class="fas fa-clock mr-1"></i>未上传
                    </div>
                    <div class="flex space-x-2">
                      <button class="btn-file-action btn-download">
                        <i class="fas fa-download mr-1"></i>下载模板
                      </button>
                      <button class="btn-file-action btn-download">
                        <i class="fas fa-file-alt mr-1"></i>下载范文
                      </button>
                      <button class="btn-file-action btn-upload">
                        <i class="fas fa-upload mr-1"></i>上传文件
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-8 flex justify-between">
              <button class="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300 transition-colors">
                <i class="fas fa-arrow-left mr-2"></i>上一步
              </button>
              <button class="px-6 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors opacity-50 cursor-not-allowed">
                提交材料<i class="fas fa-arrow-right ml-2"></i>
              </button>
            </div>
          </div>
        </div>
        >
      </div>

      <div class="bg-white rounded-xl shadow-md p-6 mt-8">
        <div class="flex items-center mb-4">
          <i class="fas fa-question-circle text-blue-500 mr-2"></i>
          <h2 class="text-xl font-semibold text-gray-800">常见问题</h2>
        </div>
        <div class="space-y-4">
          <div>
            <h3 class="font-medium text-gray-800 mb-1">问：所有文件都需要同时上传吗？</h3>
            <p class="text-gray-600 text-sm">答：您可以分批上传文件，系统会自动保存您的上传进度。建议在提交前确保所有文件都已上传完成。</p>
          </div>
          <div>
            <h3 class="font-medium text-gray-800 mb-1">问：文件上传有什么格式和大小限制？</h3>
            <p class="text-gray-600 text-sm">答：支持PDF、Word、Excel等常见文档格式，单个文件大小不超过20MB。建议将图片类文件压缩后再上传。</p>
          </div>
          <div>
            <h3 class="font-medium text-gray-800 mb-1">问：如何获取文件模板和范文？</h3>
            <p class="text-gray-600 text-sm">答：每个文件项旁边都有"下载模板"和"下载范文"按钮，点击即可获取相应文件参考。</p>
          </div>
          <div>
            <h3 class="font-medium text-gray-800 mb-1">问：提交后还能修改或补充文件吗？</h3>
            <p class="text-gray-600 text-sm">答：在安保部审核完成前，您可以联系场馆工作人员申请修改或补充文件。审核通过后将无法修改。</p>
          </div>
        </div>
      </div>
    </main>

    <!-- 浮动按钮：我需要代办服务 -->
    <button class="floating-btn" type="button" @click="handleAgency">
      我需要
      <br>代办服务
    </button>
  </div>
</template>
<script>
import StepOne from "./StepOne";
export default {
  name: "Hdsblc",
  components: {StepOne},
  data() {
    return {
      step: 1,
    }
  },
  mounted() {
      // 为需要填报资料的节点添加点击效果
      const formSteps = document.querySelectorAll('.form-step');
      formSteps.forEach(step => {
        step.addEventListener('click', function() {
          // 这里可以添加点击后的逻辑，比如显示详情弹窗
          if (!this.classList.contains('step-active')) {
            alert('请先完成当前步骤，再进行下一步操作。');
          }
        });
      });

      // 平滑滚动
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
          e.preventDefault();
          document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
          });
        });
      });

      // 监听滚动，为元素添加动画
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.animationPlayState = 'running';
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });

      document.querySelectorAll('.animate-fade-in').forEach(el => {
        el.style.animationPlayState = 'paused';
        observer.observe(el);
      });

      // 文件上传按钮点击事件
      const uploadButtons = document.querySelectorAll('.btn-upload');
      uploadButtons.forEach(button => {
        button.addEventListener('click', function() {
          // 这里可以添加文件上传的逻辑
          // 模拟文件上传成功
          const statusBadge = this.closest('.document-item').querySelector('.status-badge');
          statusBadge.classList.remove('status-pending');
          statusBadge.classList.add('status-completed');
          statusBadge.innerHTML = '<i class="fas fa-check mr-1"></i>已上传';

          // 更改按钮文本
          this.innerHTML = '<i class="fas fa-redo mr-1"></i>重新上传';

          // 更新进度条
          updateProgressBar();

          // 检查是否所有文件都已上传
          checkAllFilesUploaded();
        });
      });

      // 下载按钮点击事件
      const downloadButtons = document.querySelectorAll('.btn-download');
      downloadButtons.forEach(button => {
        button.addEventListener('click', function() {
          // 这里可以添加文件下载的逻辑
          alert('文件下载功能已触发');
        });
      });

      // 更新进度条
      function updateProgressBar() {
        const totalFiles = document.querySelectorAll('.document-item').length;
        const completedFiles = document.querySelectorAll('.status-completed').length;
        const progressPercentage = Math.round((completedFiles / totalFiles) * 100);

        const progressBar = document.querySelector('.bg-blue-600');
        const progressText = document.querySelector('.text-blue-600.ml-2');

        if (progressBar && progressText) {
          progressBar.style.width = `${progressPercentage}%`;
          progressText.textContent = `${completedFiles}/${totalFiles}`;
        }
      }

      // 检查是否所有文件都已上传
      function checkAllFilesUploaded() {
        const totalFiles = document.querySelectorAll('.document-item').length;
        const completedFiles = document.querySelectorAll('.status-completed').length;
        const submitButton = document.querySelector('button:contains("提交材料")');

        if (totalFiles === completedFiles && submitButton) {
          submitButton.classList.remove('opacity-50', 'cursor-not-allowed');
          submitButton.addEventListener('click', function() {
            alert('材料提交成功！');
          });
        }
      }

      // 移动端步骤指示器点击事件
      const mobileStepIndicator = document.querySelector('.mobile-step-indicator');
      if (mobileStepIndicator) {
        mobileStepIndicator.addEventListener('click', function() {
          const desktopStepContainer = document.querySelector('.desktop-step-container');
          if (desktopStepContainer) {
            desktopStepContainer.style.display = desktopStepContainer.style.display === 'none' ? 'block' : 'none';
          }
        });
      }
  },
  methods: {
    openRouter(){
      const { href } = this.$router.resolve({
        path: '/jlzc/ljbl/home',
        query:{}
      });
      window.open(href, '_blank', 'noopener');
    },
    handleAgency() {
      // “我需要代办服务” 按钮的逻辑
      // 可以跳转到客服/在线咨询/填写需求弹窗等
      alert('已收到您的代办服务需求，我们会尽快与您联系。');
    },
    stepSelected(num){
      this.step = num
    }
  }
}
</script>

<style scoped>
/* 浮动按钮样式 */
.floating-btn {
  position: fixed;
  right: 0px;
  bottom: 40%;
  padding: 10px 18px;
  border-radius: 999px;
  border: none;
  background: #ff8a00;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
  outline: none;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
  z-index: 1000;
}

.floating-btn:hover {
  background: #ffa033;
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

.page-content{
}

body {
  font-family: 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background-color: #f8fafc;
  color: #1e293b;
  line-height: 1.6;
}

.step-card {
  transition: all 0.3s ease;
  position: relative;
  z-index: 10;
}

.step-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
}

.form-step {
  cursor: pointer;
  /*border: 2px solid #e2e8f0;*/
}

.form-step:hover {
  border-color: #3b82f6;
  background-color: #eff6ff;
}

.step-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #3b82f6;
  color: white;
  font-weight: bold;
  font-size: 14px;
}

.step-number-active {
  background-color: #1e40af;
}

.note-box {
  background-color: #fef3c7;
  border-left: 4px solid #f59e0b;
  padding: 12px 16px;
  border-radius: 0 6px 6px 0;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.animate-fade-in {
  animation: fadeIn 0.5s ease forwards;
  opacity: 0;
}

.delay-100 { animation-delay: 0.1s; }
.delay-200 { animation-delay: 0.2s; }
.delay-300 { animation-delay: 0.3s; }
.delay-400 { animation-delay: 0.4s; }
.delay-500 { animation-delay: 0.5s; }
.delay-600 { animation-delay: 0.6s; }
.delay-700 { animation-delay: 0.7s; }
.delay-800 { animation-delay: 0.8s; }
.delay-900 { animation-delay: 0.9s; }
.delay-1000 { animation-delay: 1s; }
.delay-1100 { animation-delay: 1.1s; }

.conditional-step {
  background-color: #f0f9ff;
  border-left: 4px solid #0ea5e9;
}

.branch-container {
  position: relative;
}

.branch-text {
  position: absolute;
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
}

/* 移除左侧细线 */
.step-line {
  display: none;
}

.step-line-active {
  display: none;
}

.step-active {
  border-color: #3b82f6;
  background-color: #eff6ff;
}

.document-item {
  transition: all 0.2s ease;
}

.document-item:hover {
  background-color: #f8fafc;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 500;
}

.status-pending {
  background-color: #fef3c7;
  color: #92400e;
}

.status-completed {
  background-color: #dcfce7;
  color: #15803d;
}

.btn-file-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 0.75rem;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.btn-file-action:hover {
  transform: translateY(-1px);
}

.btn-download {
  background-color: #dbeafe;
  color: #1e40af;
}

.btn-download:hover {
  background-color: #bfdbfe;
}

.btn-upload {
  background-color: #3b82f6;
  color: white;
}

.btn-upload:hover {
  background-color: #2563eb;
}

.mobile-step-indicator {
  display: none;
}

@media (max-width: 768px) {
  .mobile-step-indicator {
    display: block;
    margin-bottom: 1.5rem;
  }

  .desktop-step-container {
    display: none;
  }

  .main-content {
    flex-direction: column;
  }

  .document-list {
    margin-top: 1.5rem;
  }
}

/* 调整流程节点容器宽度，确保11个节点完整展示 */
@media (min-width: 769px) {
  /* 增加容器宽度 */
  .desktop-step-container {
    min-width: 380px;
    max-width: 420px;
  }

  .main-content {
    display: flex;
    gap: 2rem;
  }

  .document-list {
    flex: 1;
  }
}

/* 特殊步骤样式 */
.conditional-branch {
  position: relative;
  padding-left: 24px;
  margin-top: 8px;
}

.conditional-branch::before {
  content: '';
  position: absolute;
  left: 8px;
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: #cbd5e1;
}

.conditional-branch::after {
  content: '';
  position: absolute;
  left: 0;
  top: 10px;
  width: 16px;
  height: 2px;
  background-color: #cbd5e1;
}

.food-exhibition-only {
  background-color: #f0fdf4;
  border-left: 4px solid #22c55e;
}

.food-exhibition-only::before {
  content: '仅大型食品展销会需要';
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background-color: #22c55e;
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;
}

</style>
